// removed by extract-text-webpack-plugin
module.exports = {"prefList":"_3C33Z","slider":"_3mRZq","sliderButton":"_2Dadk","numberInput":"_29r04","prefHelpText":"_2YPLq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/orchestra/OrchestraPreferences.css
// module id = 827
// module chunks = 0